'use client';

import * as React from 'react';
import { type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils/cn';
import { buttonVariants } from './button';

interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof buttonVariants> {
  href: string;
  isDisabled?: boolean;
  isExternal?: boolean;
}

/**
 * Link component based on button styling with support for external links
 * @param {object} props - Component props
 * @returns {React.ReactElement} Rendered link component
 */
export function Link({
  className,
  variant,
  size,
  href,
  isDisabled = false,
  isExternal = false,
  children,
  ...props
}: LinkProps) {
  const linkProps = {
    className: cn(
      buttonVariants({
        variant,
        size,
        className,
      }),
      isDisabled && 'pointer-events-none opacity-50',
      variant === 'link' && 'underline-offset-4 hover:underline',
    ),
    href: isDisabled ? '#' : href,
    ...props,
    ...(isExternal && {
      target: '_blank',
      rel: 'noopener noreferrer',
    }),
  };

  return <a {...linkProps}>{children}</a>;
}

export type { LinkProps };
